var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#19508A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.778 13.9985C21.778 18.294 18.2958 21.7763 14.0002 21.7763C9.70468 21.7763 6.22241 18.294 6.22241 13.9985C6.22241 9.70293 9.70468 6.2207 14.0002 6.2207V7.77626C10.5637 7.77626 7.77797 10.562 7.77797 13.9985C7.77797 17.4349 10.5637 20.2207 14.0002 20.2207C17.4366 20.2207 20.2224 17.4349 20.2224 13.9985C20.2224 11.8598 19.1434 9.97307 17.5 8.8531L17.5002 10.8874H15.9446V6.2207H20.6113V7.77626L18.6675 7.77617C20.5563 9.19519 21.778 11.4542 21.778 13.9985Z",
    fill: "#19508A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refreshIcon.bca06604772d7f6a342039064de88d04.svg";
export { ForwardRef as ReactComponent };